import { useState } from 'react'
import { LogInScreen } from './log-in-screen'
import { LogInFormValues } from './components'
import { useAuth } from 'app/provider/auth'
import { useLogIn } from './commands'
import { useRouter } from 'solito/router'
import { LogInOutputToAuthUserConverter } from './converters'
import { createParam } from 'solito'
import { useIFrame } from 'app/provider/iframe'
import { useCurrentRoute } from 'app/hooks'

const { useParam } = createParam<{ offerSlug: string }>()
export interface LogInProps {
  offerSlug?: string
  isEmbed?: boolean
}

export const LogInScreenContainer = (props: LogInProps) => {
  const [mutate, { loading, error }] = useLogIn()
  const { logIn } = useAuth()
  const { replace } = useRouter()
  const [loggingIn, setLoggingIn] = useState(false)
  const [slug] = useParam('offerSlug')
  const { microsite } = useIFrame()
  const {
    getPreviousRoute,
    removePreviousRoute,
  } = useCurrentRoute();

  const offerSlug = props.offerSlug || slug

  const handleSubmit = async (values: LogInFormValues) => {
    try {
      setLoggingIn(true)

      await mutate({
        variables: {
          email: values.email,
          password: values.password,
        },

        onCompleted: async (data) => {
          const user = LogInOutputToAuthUserConverter.convert(data)

          if (!user?.token) {
            return
          }

          await logIn(user)

          if (!user.completedMarketing) {
            replace('/onboarding/opt-in')
            return
          }

          // TODO: Uncomment this when we need freshers
          // if (!user.ucasNumber && !user.universityEmail) {
          //   replace('/onboarding/education-status')
          //   return
          // }

          if (!user.ucasNumber && !user.universityEmail) {
            replace('/onboarding/student/university-email')
            return
          }

          if (microsite?.slug) {
            replace(`/microsite/${microsite.slug}`)
            return
          }

          if (props.isEmbed && offerSlug) {
            replace(`/offers/embed/${offerSlug}`)
            return
          }

          const previousRoute = await getPreviousRoute();

          replace(previousRoute || '/student-discount')

          removePreviousRoute()
        },
      })

      // Sleep for a bit to give the the frontend the chance to navigate to the next screen
      await new Promise((resolve) => setTimeout(resolve, 4000))
    } catch (error) {
      console.log(error)
    } finally {
      setLoggingIn(false)
    }
  }

  return (
    <LogInScreen
      loading={loading || loggingIn}
      error={error?.message}
      onSubmit={handleSubmit}
      isEmbed={props.isEmbed}
    />
  )
}
